import apiClient from '@/services/api'

export default {
  async getBookmarks({ commit }) {
    try {
      const { data } = await apiClient.get('/api/bookmarks')

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      commit('SET_BOOKMARKS', data.items)
    } catch (error) {
      throw error.message
    }
  },

  async createBookmark({ state, rootState, commit }, { bookmark }) {
    try {
      const { data } = await apiClient.post('/api/bookmarks', {
        ...bookmark,
        associate: rootState.applicationState.associate.id
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      commit('SET_BOOKMARKS', [{ id: data.id, ...bookmark }, ...state.bookmarks])
    } catch (error) {
      throw error.message
    }
  },

  async updateBookmark({ state, commit, rootState }, { bookmark }) {
    try {
      const { data } = await apiClient.patch(`/api/bookmarks/${bookmark.id}`, {
        ...bookmark,
        associate: rootState.applicationState.associate.id
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      commit(
        'SET_BOOKMARKS',
        state.bookmarks.map(item => (item.id === bookmark.id ? bookmark : item))
      )
    } catch (error) {
      throw error.message
    }
  },

  async deleteBookmark({ state, commit }, { id }) {
    try {
      const { data } = await apiClient.delete(`/api/bookmarks/${id}`)

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      commit(
        'SET_BOOKMARKS',
        state.bookmarks.filter(item => item.id !== id)
      )
    } catch (error) {
      throw error.message
    }
  }
}
